import { href, redirect } from 'react-router';
import type { Route } from './+types/_index';

export const clientMiddleware: Array<Route.MiddlewareFunction> = [
  ({ params }) => {
    return redirect(href('/projects/:projectId/settings/teams/:teamId/:tabId', { ...params, tabId: 'joined' }));
  },
];
